<template>
  <div class="page">
    <div v-if="view">
      <div class="cont" v-if="items.length>0">
        <header-body advertisingPosition="3" source="team"></header-body>
        <p class="title">
          共
          <span>{{ totalItems }}</span> 个代理人
        </p>
        <div>
          <van-list
            v-model="loading"
            :finished="finished"
            finished-text="没有更多了"
            :immediate-check="check"
            @load="onLoad"
          >
            <div class="list" v-for="(item,i)  in items" :key="i" :id="'agent_id'+i">
              <div class="list-left">
                <img class="list_headImg" :src="item.headUrl?item.headUrl:img" alt />
                <div class="list_zhong">
                  <p>
                    <i class="nickName">{{ item.name }}</i>
                    <span>{{ item.grade }}</span>
                  </p>
                  <p>{{ item.mobile }}</p>
                </div>
              </div>
              <div class="list-right">
                <div class="list-right-left">
                  <p>销售产品</p>
                  <p>{{ item.makeOrderNum }}单</p>
                </div>

                <div class="list-right-right">
                  <p>为您赚钱</p>
                  <p>
                    <img src="../img/jifen.png" alt />
                    <span>{{ item.integral }}</span>
                  </p>
                </div>
              </div>
            </div>
          </van-list>
        </div>
      </div>

      <kong v-if="items.length === 0"></kong>
    </div>
    <footer-body></footer-body>
  </div>
</template>

<script>
import footerBody from "../../common/footer/footer";
import headerBody from "../../common/header/header";
import kong from "../../common/kong/kong";

export default {
  name: "teamHome",
  data() {
    return {
      items: [],
      q: {
        page: "1",
        limit: "10"
      },
      loading: false,
      finished: false,
      view: false,
      check: false,
      img: require("../img/header.png"),
      totalItems: 0,
      channelType:""
    };
  },
  computed: {},
  components: {
    footerBody,
    headerBody,
    kong
  },
  filters: {},
  created() {
    this.myTeam();
    this.channelType = JSON.parse(sessionStorage.getItem("user")).channelType;
    if(this.channelType == 'app') UnionDrugHealthy.hiddenShareIcon()
  },
  methods: {
    myTeam() {
      
      this.$api.myTeam(this.q).then(res => {
        this.view = true;
        this.totalItems = res.data.paging.totalItems;
        console.log(1,this.totalItems)
        this.items = this.items.concat(res.data.body);
        // 加载状态结束
        this.loading = false;
        // 数据全部加载完成
        if (res.data.body.length < 10) {
          this.finished = true;
        }
        let time1 = new Date().getTime();
        window.onbeforeunload = e => {
          let time2 = new Date().getTime();
          let dateDiff = (time2 - time1) / 1000;
          let page_type = "team";
          this.$trackFn.view("$pageview", {
            page_type: page_type,
            event_duration: dateDiff
          }); // 商品列表页 ——浏览埋点
          sessionStorage.setItem("pageType", page_type);
          // return "关闭提示";
        };
        this.items.forEach((item, index) => {
          this.$nextTick(() => {
            this.$trackFn.load("agent_id" + index, "view_material", {
              // 曝光 - 埋点
              page_type: "team",
              card_type: "agent_list",
              card_position: index + 1,
              material_id: item.memberId,
              material_type: "agent_id",
              material_position: index + 1
            });
          });
        });
      });
    },
    onLoad() {
      this.q.page++;
      this.myTeam();
    }
  }
};
</script>

<style scoped>
.title {
  padding: 30px 0;
  color: #999999;
}

.title span {
  color: #404040;
  font-size: 28px;
}

.list_headImg {
  width: 72px;
  height: 72px;
  border-radius: 50%;
}

.list {
  padding: 34px 20px;
  background: rgba(255, 255, 255, 1);
  border-radius: 12px;
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}

.list_zhong .nickName {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  word-break: break-all;
  max-width: 170px;
  background: transparent;
  font-style: normal;
  font-size: 30px !important;
  font-weight: bold;
}

.list_zhong p {
  display: flex;
  align-items: center;
}

.list_zhong p:first-child {
  color: #404040;
  font-size: 28px;
}

.list_zhong p:last-child {
  margin-top: 12px;
  color: #999999;
}

.list_zhong p span {
  width: 44px;
  height: 26px;
  margin-left: 12px;
  line-height: 28px;
  font-size: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: url("../img/vip.png") no-repeat center;
  background-size: 44px 24px;
  color: #fff;
  box-sizing: border-box;
  padding-top: 1px;
}

.list_zhong {
  margin-left: 30px;
}

.list-left {
  display: flex;
  align-items: center;
  width: 50%;
}

.list-right {
  display: flex;
  align-items: center;
  width: 50%;
  justify-content: flex-end;
}

.list-right-left {
  text-align: right;
  margin-right: 66px;
}

.list-right-left p:first-child {
  margin-bottom: 20px;
  color: #999999;
}

.list-right-left p:last-child {
  color: #404040;
  font-weight: bold;
}

.list-right-right {
  text-align: right;
}

.list-right-right p:first-child {
  margin-bottom: 20px;
  color: #999999;
}

.list-right-right p:last-child {
  color: #dd2b1e;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.list-right-right p:last-child img {
  width: 28px;
  height: 28px;
  margin-right: 4px;
}
</style>
